import useUserData from 'approot/shared/user/user-data';

export const useFeatureCanAccessStudents = () => {
  const { isAccountExpired } = useUserData();

  return !isAccountExpired;
};
